import firebase from 'firebase';

export const rejectPolicy = async (sub) => {
    const db = firebase.firestore();
    try {
        const snapshot = db.collection("policySubmissions").doc(sub.companyName.toLowerCase()).collection("submissions").doc(sub.id);
        await snapshot.update({ deleted: true });
    } catch (error) {
        console.log('error: ', error);
    }
}

export const undeletePolicy = async (sub) => {
    const db = firebase.firestore();

    try {
        const snapshot = db.collection("policySubmissions").doc(sub.companyName.toLowerCase()).collection("submissions").doc(sub.id);
        await snapshot.update({ deleted: false });
    } catch (error) {
        console.log('error undeleting policy: ', error);
    }
}

export const approvePolicy = async (sub) => {
    const db = firebase.firestore();

    try {
        const companyRef = db.collection("company-data").doc(sub.companyName);
        const subRef = db.collection("policySubmissions").doc(sub.companyName.toLowerCase()).collection("submissions").doc(sub.id);

        const currentCompanyData = await companyRef.get();
        const subDoc = await subRef.get();

        if (currentCompanyData.exists) {
            let data = currentCompanyData.data();
            await companyRef.update({ priorPolicy: data });
        }
        await subRef.update({ verified: true });
        const updatedSub = await subRef.get();
        await companyRef.set(updatedSub.data());
    } catch (error) {
        console.log('error verifying the company policy: ', error);
    }
}